import { render, staticRenderFns } from "./u-cell-item.vue?vue&type=template&id=2c031e35&scoped=true&"
import script from "./u-cell-item.vue?vue&type=script&lang=js&"
export * from "./u-cell-item.vue?vue&type=script&lang=js&"
import style0 from "./u-cell-item.vue?vue&type=style&index=0&id=2c031e35&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c031e35",
  null
  
)

component.options.__file = "node_modules/uview-ui/components/u-cell-item/u-cell-item.vue"
export default component.exports